import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import Paper from "Components/UI/Paper";
import {
  createLogEndcustomer,
  getEndcustomerAccountsByEndcustomerId,
  getEndcustomerInfoV2,
} from "API/swesum";
import { useNavigate } from "react-router-dom";
import EndcustomerForm from "Components/Endcustomer/EndcustomerForm";

import { Grid } from "@mui/material";
import { Tab, Tabs } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { AGREEMENT_OPTIONS } from "utils/options/AGREEMENT_OPTIONS";
import EndcustomerInvoices from "../../../../../Components/Endcustomer/Workflows/EndcustomerInvoices";

import { BOOLVALUE } from "utils/options/BOOLVALUE";
import { COUNTRYCODE } from "utils/options/COUNTRYCODE";
import { LANGUAGECODE } from "utils/options/LANGUAGECODE";
import Logs from "Components/Workflows/Logs/Logs";
import { useClients } from "Context/Clients";
import { useEndCustomers } from "Context/EndCustomers";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useAuth } from "Hooks/useAuth";
import EndcustomerAccountsTableContainer from "Components/Account/EndcustomerAccountTableContainer";
import { useArticles } from "Context/Articles";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

const mockedUCValues = {
  UC_OrganisationNumber: "49889849",
  UC_CreditRating: "",
  UC_CreditForecast: "",
  UC_CreditLimit: "",
  UC_NumberOfComplaints: "",
  UC_SumOfComplaints: 5,
  UC_NumberOfClaims: "",
  UC_SumOfClaims: "",
  UC_NumberOfCases: "",
  UC_DateOfHistoricallyDebt: "",
  UC_IncludedInGroup: "",
  UC_GroupName: "",
  UC_NetSales: "",
  UC_ResultAfterFinancialIncomeAndExpenses: "",
  UC_TotalShareholdersEquity: "",
  UC_ShareCapital: "",
  UC_NumberOfEmployees: "",
  UC_RegistrationDate: "",
  UC_Status: "OKEY",
  UC_Message:
    "Detta är ett mockat värde.Ersätt formdata.UC med det riktiga objektet när det är implementerat.",
  UC_CreateTime: "2023-07-11",
};

const getInitialFormData = (endcustomer) => {
  return {
    Id: endcustomer.Id ? endcustomer.Id : "",
    OrgNo: endcustomer.OrgNo ? endcustomer.OrgNo : "",
    Name: endcustomer.Name,
    Name2: endcustomer.Name2,
    Address: endcustomer.Address,
    Address2: endcustomer.Address2,
    PostalCode: endcustomer.PostalCode,
    City: endcustomer.City,
    CountryCode: endcustomer.CountryCode,
    ExternalCustomerNr: endcustomer.ExternalCustomerNr,
    ClientId: endcustomer.ClientId,
    LatePaymentInterestPercentage: endcustomer.LatePaymentInterestPercentage,
    AddReferencePercentage: endcustomer.AddReferencePercentage,
    OriginalFfd: endcustomer.OriginalFfd,
    Pm1Ffd: endcustomer.Pm1Ffd,
    Pm1Fee: endcustomer.Pm1Fee,
    Pm1WaitCreate: endcustomer.Pm1WaitCreate,
    Pm2Ffd: endcustomer.Pm2Ffd,
    Pm2Fee: endcustomer.Pm2Fee,
    Pm2WaitCreate: endcustomer.Pm2WaitCreate,
    CollectionWaitCreate: endcustomer.CollectionWaitCreate,
    DefaultAgreement: endcustomer.DefaultAgreement,
    CreateTime: endcustomer.CreateTime,
    ParseMessage: endcustomer.ParseMessage,
    ParseStatus: endcustomer.ParseStatus,
    SystemStatus: endcustomer.SystemStatus,
    SameAgreementAsClient: endcustomer.SameAgreementAsClient,
    UC: mockedUCValues,
    UC_OrganisationNumber: endcustomer.UC_OrganisationNumber
      ? endcustomer.UC_OrganisationNumber
      : "",
    UC_NumberOfComplaints: endcustomer.UC_NumberOfComplaints
      ? endcustomer.UC_NumberOfComplaints
      : "",
    UC_Status: endcustomer.UC_Status ? endcustomer.UC_Status : "",
    UC_Message: endcustomer.UC_Message ? endcustomer.UC_Message : "",
    UC_CreateTime: endcustomer.UC_CreateTime ? endcustomer.UC_CreateTime : "",
    VATRegistration: endcustomer.VATRegistration,
    TelephoneNumber: endcustomer.TelephoneNumber,
    ContactEmail: endcustomer.ContactEmail,
    InvoiceEmail: endcustomer.InvoiceEmail,
    ReminderEmail: endcustomer.ReminderEmail,
    DeliveryOptionInvoice: endcustomer.DeliveryOptionInvoice,
    DeliveryOptionReminder: endcustomer.DeliveryOptionReminder,
    LanguageCode: endcustomer.LanguageCode,
    DefaultService: endcustomer.DefaultService,
    ReminderStop: endcustomer.ReminderStop,
  };
};

export default function EndCustomerCard() {
  const { isAdmin } = useAuth();
  const { getEndCustomerByEndCustomerId, updateEndCustomer } =
    useEndCustomers();
  const { clients, fetchClients } = useClients();
  const { endcustomerID } = useParams();
  const navigate = useNavigate();
  const articles = useArticles();

  let endCustomerArticleMap, fetchEndCustomerArticles;
  if (isAdmin) {
    ({ endCustomerArticleMap, fetchEndCustomerArticles } = articles);
  }

  useEffect(() => {
    fetchClients();
  }, [clients]);

  const boolOptions = BOOLVALUE;
  const countryCodes = COUNTRYCODE;
  const languageCodes = LANGUAGECODE;

  const [editMode, setEditMode] = useState(false);
  const [endCustomer, setEndCustomer] = useState(null);
  const [logs, setLogs] = useState(null);
  const [users, setUsers] = useState([]);
  const [accounts, setAccounts] = useState([]);

  const [formData, setFormData] = useState(null);

  const agreementOptions = AGREEMENT_OPTIONS;

  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  const fetchExtraEndCustomerInfo = async (endCustomerId) => {
    if (!isAdmin) return;

    const data = await getEndcustomerInfoV2(endCustomerId);
    const [users, logs] = data;
    const accounts = await getEndcustomerAccountsByEndcustomerId(
      endCustomerId,
      {
        Order: {
          Column: "CreateTime",
          Order: 1,
        },
        Page: 0,
        PageSize: 0,
      }
    );
    setAccounts(accounts.Rows);
    setUsers(users);
    setLogs(logs);
  };

  useEffect(() => {
    const asyncInitView = async () => {
      fetchExtraEndCustomerInfo(endcustomerID);
      const tmpEndCustomer = await getEndCustomerByEndCustomerId(endcustomerID);
      setFormData(getInitialFormData(tmpEndCustomer));
      setEndCustomer(tmpEndCustomer);
    };
    asyncInitView();
  }, [endcustomerID]);

  const { openSuccess, openError } = usePopupNotificationContext();

  const handleUpdateCustomer = async () => {
    const res = await updateEndCustomer(endCustomer.Id, formData);
    if (res.status === 201) {
      openSuccess(
        `Sparat! ${res.data.ParseMessage && res.data.ParseMessage} `,
        3000
      );
    } else {
      openError("Ett fel har uppstått", 3000);
    }
  };

  useEffect(() => {
    if (isAdmin) fetchEndCustomerArticles();
  }, []);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  if (!formData) {
    return null;
  }

  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 1 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Slutkundkort - {endCustomer.Name}
            </Typography>
            <EndcustomerForm
              formData={formData}
              FORM_MODE={editMode ? "EDIT" : "LOCKED"}
              handleInputChange={handleInputChange}
              countryCodes={countryCodes}
              languageCodes={languageCodes}
              agreementOptions={agreementOptions}
              clients={clients}
              boolOptions={boolOptions}
            />
            <Grid
              item
              xs={12}
              sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
            >
              {editMode ? (
                <>
                  <Button
                    size="small"
                    onClick={() => setEditMode(false)}
                    sx={{ ml: 1 }}
                  >
                    Stäng
                  </Button>
                  <Button
                    size="small"
                    onClick={handleUpdateCustomer}
                    variant="contained"
                    sx={{ ml: 3 }}
                  >
                    Spara
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    size="small"
                    onClick={() => navigate(-1)}
                    sx={{ ml: 1 }}
                  >
                    Stäng
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setEditMode(true)}
                    variant="contained"
                    sx={{ ml: 3, display: editMode ? "none" : "block" }}
                  >
                    Editera
                  </Button>
                </>
              )}
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} md={12}>
          <Paper>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Reskontra" />
              {isAdmin && <Tab label="Slutkundshändelser" />}
              {isAdmin && <Tab label="Loggar" />}
            </Tabs>

            <TabPanel value={tabIndex} index={0} id="tabpanel0">
              {endCustomer ? (
                <EndcustomerInvoices endcustomer={endCustomer} />
              ) : null}
            </TabPanel>

            {isAdmin ? (
              <>
                <TabPanel value={tabIndex} index={1} id="tabPanel0">
                  <EndcustomerAccountsTableContainer accounts={accounts} />
                </TabPanel>

                <TabPanel value={tabIndex} index={2} id="tabPanel0">
                  <Logs
                    entityID={endCustomer.Id}
                    logs={logs}
                    users={users}
                    call={createLogEndcustomer}
                    checkbox={true}
                  />
                </TabPanel>
              </>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
